/* eslint-disable */
import React, { useState } from 'react';
import PhoneScannerScreen from '../PhoneScannerScreen';

const stripSerial=(s)=>{const m=s.match(/\/sn\/([^/?#]+)/);if(m)return m[1].trim();const m2=s.match(/sn([A-Za-z0-9]+)$/i);if(m2)return m2[1].trim();if(s.startsWith("http")){const p=s.replace(/\/$/,"").split("/");return p[p.length-1].trim();}return s;};

/**
 * ScanInSheet — scan a device QR, find its open allocation, confirm return.
 */
export default function ScanInSheet({ st, setSt, shiftId, account, audit, onBack, onSuccess, prefilledAllocationId }) {
  const shift = (st.shifts || []).find(s => s.id === shiftId);

  const prefilled = prefilledAllocationId ? (() => {
    const a = (st.allocations || []).find(x => x.id === prefilledAllocationId && x.shiftId === shiftId && x.status === 'out');
    if (!a) return null;
    const d = (st.devices || []).find(x => x.id === a.deviceId);
    return d ? { alloc: a, device: d } : null;
  })() : null;

  const [matchedAlloc, setMatchedAlloc] = useState(prefilled ? prefilled.alloc : null);
  const [matchedDevice, setMatchedDevice] = useState(prefilled ? prefilled.device : null);
  const [error, setError] = useState(null);
  const [manualSerial, setManualSerial] = useState('');
  const [notes, setNotes] = useState('');

  const handleScan = (code) => {
    const serial = stripSerial(code);
    const device = (st.devices || []).find(d =>
      d.serial === serial || d.serial === code || d.id === serial ||
      (d.serial && d.serial.toLowerCase().includes(serial.toLowerCase()))
    );

    if (!device) {
      setError(`Device not found: ${serial}`);
      return;
    }

    // Find open allocation on this shift
    const alloc = (st.allocations || []).find(a => a.deviceId === device.id && a.shiftId === shiftId && a.status === 'out');
    if (!alloc) {
      // Check if open on a different shift
      const otherAlloc = (st.allocations || []).find(a => a.deviceId === device.id && a.status === 'out');
      if (otherAlloc) {
        const otherShift = (st.shifts || []).find(s => s.id === otherAlloc.shiftId);
        setError(`This device is open on ${otherShift ? 'Shift ' + otherShift.shiftNumber : 'another shift'}, not this one.`);
      } else {
        setError(`No open allocation for ${serial} on this shift. Did you mean scan out?`);
      }
      return;
    }

    setError(null);
    setMatchedAlloc(alloc);
    setMatchedDevice(device);
  };

  const handleConfirm = () => {
    if (!matchedAlloc) return;
    const now = new Date().toISOString();

    setSt(prev => ({
      ...prev,
      allocations: prev.allocations.map(a =>
        a.id === matchedAlloc.id
          ? { ...a, status: 'returned', inAt: now, notes: notes ? (a.notes ? a.notes + ' | ' + notes : notes) : a.notes }
          : a
      ),
      devices: prev.devices.map(d => d.id === matchedDevice.id ? { ...d, availability: 'available' } : d),
    }));

    audit('allocation_returned', { shiftId, allocationId: matchedAlloc.id, deviceId: matchedDevice.id });

    if (onSuccess) onSuccess({ device: matchedDevice, alloc: matchedAlloc });
  };

  const fmtTime = (d) => d ? new Date(d).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }) : '—';

  const durationStr = (outAt) => {
    if (!outAt) return '—';
    const ms = Date.now() - new Date(outAt).getTime();
    const h = Math.floor(ms / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    return `${h}h ${m}m`;
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      {/* Header */}
      <div style={{ padding: '8px 20px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'var(--surface-app)', borderBottom: '1px solid var(--border-subtle)', flexShrink: 0 }}>
        <button onClick={onBack} style={{ width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', border: '1px solid var(--border-default)', borderRadius: '50%', color: 'var(--text-muted)', cursor: 'pointer' }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
        <div style={{ textAlign: 'center', flex: 1 }}>
          <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text-default)' }}>Scan device in</div>
          <div style={{ fontSize: 11, color: 'var(--text-subtle)', marginTop: 2 }}>Shift {shift?.shiftNumber} · {shift?.possessionRef}</div>
        </div>
        <div style={{ width: 36 }} />
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: 20 }}>
        {/* Device lookup — manual input + optional camera */}
        {!matchedAlloc && !error && (
          <div style={{ marginBottom: 14 }}>
            <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
              <input
                autoFocus
                value={manualSerial}
                onChange={e => setManualSerial(e.target.value)}
                onKeyDown={e => { if (e.key === 'Enter' && manualSerial.trim()) handleScan(manualSerial.trim()); }}
                placeholder="Enter serial number or scan QR..."
                style={{ flex: 1, padding: '12px 14px', background: 'var(--surface-inset)', border: '1px solid var(--border-default)', borderRadius: 10, color: 'var(--text-default)', fontFamily: 'inherit', fontSize: 14, boxSizing: 'border-box' }}
              />
              <button
                onClick={() => manualSerial.trim() && handleScan(manualSerial.trim())}
                disabled={!manualSerial.trim()}
                style={{ padding: '12px 18px', borderRadius: 10, border: 'none', background: manualSerial.trim() ? '#ff530d' : 'var(--surface-raised)', color: manualSerial.trim() ? '#fff' : 'var(--text-subtle)', fontWeight: 600, fontSize: 13, cursor: manualSerial.trim() ? 'pointer' : 'not-allowed', fontFamily: 'inherit', whiteSpace: 'nowrap' }}
              >
                Look up
              </button>
            </div>
            <div style={{ textAlign: 'center', fontSize: 11, color: 'var(--text-subtle)', marginBottom: 10 }}>or scan with camera</div>
            <div style={{ borderRadius: 14, overflow: 'hidden', background: '#111', border: '1px solid var(--border-default)' }}>
              <PhoneScannerScreen onScan={handleScan} compact />
            </div>
            <div style={{ textAlign: 'center', fontSize: 11, color: 'var(--text-subtle)', marginTop: 10 }}>
              Any deployment user can scan returns — shift continuity preserved
            </div>
          </div>
        )}

        {/* Error */}
        {error && (
          <div style={{ background: 'rgba(248,113,113,0.12)', border: '1px solid #f87171', borderRadius: 10, padding: '12px 14px', fontSize: 12, color: '#f87171', marginBottom: 16 }}>
            <strong style={{ display: 'block', color: 'var(--text-default)', marginBottom: 2 }}>Scan issue</strong>
            {error}
            <button onClick={() => { setError(null); setMatchedAlloc(null); setMatchedDevice(null); setManualSerial(''); }} style={{ marginTop: 8, display: 'block', background: 'transparent', border: '1px solid #f87171', borderRadius: 6, color: '#f87171', padding: '6px 12px', fontSize: 11, fontWeight: 600, cursor: 'pointer' }}>Try again</button>
          </div>
        )}

        {/* Matched allocation */}
        {matchedAlloc && matchedDevice && (
          <>
            <div style={{ background: 'rgba(255,83,13,0.15)', border: '1px solid rgba(255,83,13,0.35)', borderRadius: 14, padding: 14, marginBottom: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                <span style={{ fontSize: 18, fontWeight: 700, color: '#ff530d', fontVariantNumeric: 'tabular-nums', fontFamily: matchedAlloc.anonDeviceLabel ? 'monospace' : 'inherit' }}>{matchedAlloc.anonDeviceLabel || matchedDevice.serial}</span>
                <span style={{ fontSize: 11, color: 'var(--text-default)', padding: '3px 8px', background: 'rgba(0,0,0,0.3)', borderRadius: 4, fontWeight: 500 }}>{matchedDevice.type}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, marginTop: 4 }}>
                <span style={{ color: 'var(--text-muted)' }}>Open allocation</span>
                <span style={{ color: 'var(--text-default)', fontWeight: 500 }}>{matchedAlloc.role} · {matchedAlloc.operativeName || 'Unassigned'}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, marginTop: 4 }}>
                <span style={{ color: 'var(--text-muted)' }}>Out at</span>
                <span style={{ color: 'var(--text-default)', fontWeight: 500 }}>{fmtTime(matchedAlloc.outAt)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, marginTop: 4 }}>
                <span style={{ color: 'var(--text-muted)' }}>Duration out</span>
                <span style={{ color: 'var(--text-default)', fontWeight: 500 }}>{durationStr(matchedAlloc.outAt)}</span>
              </div>
            </div>

            <div style={{ marginBottom: 14 }}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 6 }}>
                Return notes <span style={{ color: 'var(--text-subtle)', fontWeight: 400, textTransform: 'none', letterSpacing: 0 }}>(optional)</span>
              </label>
              <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="Any damage, issues, or comments" style={{ width: '100%', padding: '10px 12px', background: 'var(--surface-inset)', border: '1px solid var(--border-default)', borderRadius: 10, color: 'var(--text-default)', fontFamily: 'inherit', fontSize: 14, resize: 'none', minHeight: 60, boxSizing: 'border-box' }} />
            </div>

            <button onClick={handleConfirm} style={{ width: '100%', padding: 13, borderRadius: 10, border: 'none', fontFamily: 'inherit', fontSize: 14, fontWeight: 600, cursor: 'pointer', background: '#ff530d', color: '#fff' }}>
              Confirm return · In now
            </button>
          </>
        )}
      </div>
    </div>
  );
}
